<template>
  <div
    class="modal fade join-class"
    tabindex="-1"
    role="dialog"
    aria-labelledby="myLargeModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-md modal-join">
      <b-form @submit="onSubmit">
        <div class="modal-content">
          <h3 class="primary-color-txt font-sanpro-semibold font-size-24">Tham gia lớp học</h3>
          <div class="class-code">
            <label for class="secondary-color-txt font-sanpro-semibold font-size-16">Mã lớp</label>
            <br />
            <input
              required
              v-model="keyword"
              v-debounce="300"
              type="text"
              class="form-control"
              placeholder="ABCXYZ12345"
            />
          </div>
          <div class="item-class display-flex" v-if="getClassSchool && !getClassSchool.isJoined && checkDisplay  && keyword !=''">
            <div class="info-left display-flex">
              <img src="@/assets/img/icon-list.png" alt />
              <div class="info-class text-left">
                <h2 class="primary-color font-sanpro-semibold font-size-16">{{getClassSchool.name}}</h2>
                <h3
                  class="secondary-color-txt font-family-Semibold font-size-14"
                >Trường Tiểu học Nguyễn Tất Thành</h3>
                <h3 class="primary-color font-family-Semibold font-size-14">{{getClassSchool.numberOfStudent}}</h3>
              </div>
            </div>
          </div>
          <h3 v-if=" getClassSchool.isJoined && checkDisplay " class="secondary-color-txt font-sanpro-semibold font-size-20 mt-2 mb-4">
              Bạn đã tham gia lớp học này
        </h3> 
        <h3 v-if=" !checkDisplay  && keyword !='' " class="secondary-color-txt font-sanpro-semibold font-size-20 mt-2 mb-4">
              Mã lớp không tồn tại
        </h3>     
        <h3 v-if="keyword===''" class="secondary-color-txt font-sanpro-semibold font-size-20 mt-2 mb-4">
              Vui lòng nhập mã lớp
        </h3>
          <div class="footer-modal">
            <button type="button" class="btn btn-secondary close-cls" data-dismiss="modal">Hủy</button>
            <button type="submit" class="btn btn-primary join-cls">Tham gia</button>
          </div>
        </div>
      </b-form>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { STORE_KEY } from "../../_store/constants";
import ModalJoinClass from "../../_components/modalClass/ModalJoinClass";
import debounce from "@/directives/debounce";
import { getSerachClass } from "../../_api";
import { ClassSchoolJoin } from "../../_api";
export default {
  name: "ModalJoinClass",
  directives: { debounce },
  data() {
    return {
      keyword: "",
      getClassSchool:{},
      checkjoin :false,
      checkDisplay:true,
    };
  },
  computed: {
    ...mapGetters({
      classLists: STORE_KEY + "/classLists",
      getParamListSchool: STORE_KEY + "/getParamListSchool"
    })
  },
  watch: {
    classLists(newVal, oldVal) {
      if (newVal) {
        this.pagingData = newVal.paging;
      }
    },
    keyword: "classSerach",
    classSchoolSubjectId:0,

    // getParamListSchool: "fetchSchoolList"
  },
  mounted() {
    // this.actionGetListClass({keyword:"",pageIndex:1,pageSize:10,sort:"",direction:""});
    // this.actionSetParamListSchool({ ...this.getParamListSchool, pageIndex: 1, pageSize:10});
  },
  methods: {
    ...mapActions(`${STORE_KEY}`, ["actionGetClassSchoolSubject","actionGetListClass"]),
    ...mapActions(`common`, ["setLoading"]),
    classSerach() {
        getSerachClass(this.keyword).then(res => {
          if (res.status === "success") {
            this.checkjoin = true;   
            this.checkDisplay = true;
            this.getClassSchool = res.data;
          }
          if(!res){
            this.checkDisplay = false;
          }
        });
      // this.actionSetParamListSchool({ ...this.getParamListSchool, keyword: this.keyword });
      // let data = this.EmailDepartment;
      // checkExitEmail({ email: data })
    },
    onSubmit(e) {
      e.preventDefault();
      if(!this.checkjoin){
        return
      }
      let data={};
      data["classSchoolSubjectId"] =this.getClassSchool.classSchoolSubjectId
      ClassSchoolJoin(data)
      .then(res => {
         if (res.status === "success") {
            this.keyword = "",
            this.actionGetListClass(this.getParamListSchool)
            this.$toast.success('Tham gia lớp thành công');
         }
      });
  }
  }
};
</script>

<style lang="scss" scoped>
.modal-join {
  width: 387px;
}
.modal-content {
  padding: 15px;
  .class-code {
    border-bottom: 1px solid #d8d8d8;
    padding-bottom: 25px;
    margin-bottom: 25px;
    input {
      border: 0;
      background: #f3f6fb;
      border-radius: 20px;
      height: 30px;
      font-size: 14px;
    }
    ::placeholder {
      /* Chrome, Firefox, Opera, Safari 10.1+ */
      font-size: 14px;
    }
  }
  .item-class {
    padding: 17px 0;
    border-radius: 5px;
    margin: 0 0px 18px 0px;
    position: relative;
    &:hover {
      background: #f3f6fb;
    }
    &:focus {
      background: #f3f6fb;
    }
    h2 {
      margin-bottom: 12px;
    }
    img {
      height: 78px;
      margin: 0 12px 0 18px;
    }
  }
}
.footer-modal {
  justify-content: flex-end;
  display: flex;
  button {
    border-radius: 20px;
    height: 30px;
    line-height: 15px;
  }
  .close-cls {
    background: none;
    border: 0;
    color: #124abe;
    border-radius: 20px;
    &:focus {
      background: none;
      color: #124abe;
      outline: 0;
    }
  }
  .join-cls {
    background: #124abe;
    width: 110px;
  }
}
</style>